(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-chips"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const countdownSection = document.querySelector('.countdown-section');
  if (!countdownSection) return;
  
  const viewportNode = countdownSection.querySelector('.countdown-viewport');
  
  const emblaApi = EmblaCarousel(viewportNode, {
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drinkware-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselNode = document.querySelector('.dw-carousel');
    if (!carouselNode) return;

    const viewportNode = carouselNode.querySelector('.dw-carousel__viewport');
    const emblaApi = EmblaCarousel(viewportNode, {
      align: 'start',
      dragFree: true,
      containScroll: 'trimSnaps'
    });

    const prevButton = carouselNode.querySelector('.dw-carousel__button--prev');
    const nextButton = carouselNode.querySelector('.dw-carousel__button--next');

    const updateButtonVisibility = () => {
      if (!emblaApi.canScrollPrev()) {
        prevButton.classList.add('dw-carousel__button--disabled');
      } else {
        prevButton.classList.remove('dw-carousel__button--disabled');
      }

      if (!emblaApi.canScrollNext()) {
        nextButton.classList.add('dw-carousel__button--disabled');
      } else {
        nextButton.classList.remove('dw-carousel__button--disabled');
      }
    };

    prevButton.addEventListener('click', () => {
      emblaApi.scrollPrev();
      updateButtonVisibility();
    });

    nextButton.addEventListener('click', () => {
      emblaApi.scrollNext();
      updateButtonVisibility();
    });

    emblaApi.on('select', updateButtonVisibility);
    emblaApi.on('init', updateButtonVisibility);
    emblaApi.on('reInit', updateButtonVisibility);
    emblaApi.on('settle', updateButtonVisibility);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-input');
  if (!searchInput) return;

  const gridCards = document.querySelectorAll('.grid-card');
  const noResults = document.querySelector('.no-results');

  let debounceTimer;

  searchInput.addEventListener('input', function(e) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const searchTerm = e.target.value.toLowerCase().trim();
      let hasResults = false;

      gridCards.forEach(card => {
        const searchableContent = card.dataset.searchableContent;
        if (searchableContent.includes(searchTerm)) {
          card.style.display = 'block';
          hasResults = true;
        } else {
          card.style.display = 'none';
        }
      });

      noResults.style.display = hasResults ? 'none' : 'block';
    }, 300);
  });
});

  } catch(e) { console.error(e); }
})();
})();
